import { render } from "./FormPagamento.vue?vue&type=template&id=6e3b8f07&scoped=true"
import script from "./FormPagamento.vue?vue&type=script&lang=js"
export * from "./FormPagamento.vue?vue&type=script&lang=js"

import "./FormPagamento.vue?vue&type=style&index=0&id=6e3b8f07&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3b8f07"]])

export default __exports__